/** Implied circulating supply from held ZEC and network ownership %. */
export function impliedCirculatingSupply(
  totalZecHeld: number,
  networkOwnershipPct: number,
): number {
  if (totalZecHeld > 0 && networkOwnershipPct > 0) {
    return (totalZecHeld * 100) / networkOwnershipPct;
  }
  return 0;
}

/** ZEC held at target network % given current holdings and ownership %. */
export function goalZecAtTarget(
  totalZecHeld: number,
  currentNetworkPct: number,
  targetPct: number,
): number {
  if (totalZecHeld <= 0 || currentNetworkPct <= 0) return 0;
  return totalZecHeld * (targetPct / currentNetworkPct);
}
